```vue
<template>
  <el-dialog
    title="新增配送邮费模版"
    :visible.sync="visible"
    width="600px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="邮费模版名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入名称"
          style="width: 240px"
        />
      </el-form-item>

      <el-form-item label="省份" prop="city">
        <el-select
          v-model="form.city"
          style="width: 240px"
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="首重(KG)" prop="first_number">
        <el-input
          v-model="form.first_number"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <el-form-item label="首重价格(韩元)" prop="first_amount">
        <el-input
          v-model="form.first_amount"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <el-form-item label="续重(KG)" prop="repeat_number">
        <el-input
          v-model="form.repeat_number"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <el-form-item label="续重价格(韩元)" prop="repeat_amount">
        <el-input
          v-model="form.repeat_amount"
          placeholder="请输入"
          style="width: 240px"
          @input="handleInput"
        />
      </el-form-item>

      <!-- <el-form-item label="创建时间" prop="add_time">
        <el-input
          v-model="form.add_time"
          disabled
          style="width: 240px"
        />
      </el-form-item> -->
    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">
        取 消
      </el-button>

      <el-button
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
      >
        保 存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getCityList
} from '@/api/postage'

import {
  goodsPostageAdd
} from '@/api/xgcApi'

export default {
  name: 'AddPostageDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },

    postId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      cityForm: {},
      cityList: [],
      submitLoading: false,

      form: {
        post_id: null,

        // 省份选择值
        city: [],

        // 最终提交给接口的值
        cityCode: '',

        name: '',
        first_number: '',
        first_amount: '',
        repeat_number: '',
        repeat_amount: '',
        add_time: '',
        type:''
      },

      rules: {
        name: [
          {
            required: true,
            message: '邮费模版名称不能为空',
            trigger: 'blur'
          }
        ],

        city: [
          {
            required: true,
            message: '省份不能为空',
            trigger: 'change'
          }
        ],

        first_number: [
          {
            required: true,
            message: '首件不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        first_amount: [
          {
            required: true,
            message: '首件价格不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        repeat_number: [
          {
            required: true,
            message: '续件不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ],

        repeat_amount: [
          {
            required: true,
            message: '续件价格不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
            message: '请输入数字或小数',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    visible: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    value(val) {
      if (val) {
        this.init()
      }
    },

    postId(val) {
      this.form.post_id = val
    }
  },

  methods: {
    /**
     * 初始化
     */
    async init() {
      this.resetForm()

      this.form.post_id = this.postId

      await this.list()
    },

    /**
     * 获取省份
     */
    async list() {
      try {
        const {
          data
        } = await getCityList(this.cityForm)

        this.cityList = data || []
      } catch (error) {
        console.error('获取省份列表失败', error)
      }
    },

    /**
     * 保存
     */
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false
        }

        this.submitLoading = true

        try {
          // 省份数组转换成接口需要的字符串
          this.form.cityCode = this.form.city.join(',')

          // 不需要把 city 这个前端字段提交给接口
          const submitData = {
            ...this.form
          }

          delete submitData.city

          const {
            msg
          } = await goodsPostageAdd(submitData)

          this.$message.success(msg)

          // 通知父组件刷新列表
          this.$emit('success')

          // 关闭弹窗
          this.handleClose()
        } catch (error) {
          console.error('新增邮费模板失败', error)
        } finally {
          this.submitLoading = false
        }
      })
    },

    /**
     * 关闭弹窗
     */
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.form = {
        post_id: this.postId,
        city: [],
        cityCode: '',
        name: '',
        first_number: '',
        first_amount: '',
        repeat_number: '',
        repeat_amount: '',
        add_time: ''
      }

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },

    /**
     * 输入处理
     */
    handleInput(value) {
      return value
    }
  }
}
</script>

<style scoped>
.el-form {
  padding: 10px 20px 0;
}
</style>
